export default __webpack_public_path__ + "static/heroslumpykev-4b4838c4911ce90ab0b46e748fbef05a.jpg";